import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CreateNewClothForm from '../../../../Componant/Application/Project/master/CreateNewClothForm'


const ClothCreateContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <CreateNewClothForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ClothCreateContainer